import { getConfig } from '../config'

// 登录前上报接口前缀
const API_PREFIX = '/api'

/**
 * 上报类型
 */
export const IBKReportType = {
  Event: 'event',
  Metric: 'metric'
}

/**
 * 错误级别
 */
export const BKErrorLevel = {
  Fatal: 'fatal',
  Warn: 'warn',
  Info: 'info'
}

/**
 * 登录前将页面异常上报到后端 BK 监控；请求失败不阻断主流程
 * 
 * @returns {Promise<boolean>} 成功返回 true，失败返回 false
 */
export const notLoggedReport = body =>
  (async () => {
    try {
      const url = `${API_PREFIX}/bk/captcha-report`
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      const res = await response.json()
      if (res.code !== 0) {
        console.log('notLoggedReport failed:', res)
        return false
      }
      return true
    } catch (error) {
      console.log('notLoggedReport error:', error)
      return false
    }
  })()

/**
 * 上报验证码未通过校验事件
 * @param {string} email 用户邮箱（登录前标识用户）
 */
export const captchaVerifyFailReport = (email, extraInfo = '') => {
  if (!email) {
    return
  }
  const config = getConfig()
  const body = {
    email,
    type: IBKReportType.Event,
    data: [
      {
        event_name: 'user-center_captcha_verify_fail',
        event: {
          content: `user-center page captcha verify fail：${email}, captcha extra info: ${extraInfo}`
        },
        dimension: {
          path: location.pathname,
          userID: email,
          location: config.deployArea || '-',
          module: 'web',
          level: BKErrorLevel.Warn
        },
        target: '127.0.0.1',
        timestamp: Date.now()
      }
    ]
  }
  return notLoggedReport(body)
}



// WEBPACK FOOTER //
// ./src/utils/report.js